import SiteLayout from "@/components/feature/SiteLayout";
import useSeo from "@/hooks/useSeo";
import { articles } from "@/mocks/articles";
import { site } from "@/mocks/site";
import Hero from "./components/Hero";
import CategoryAndLevels from "./components/CategoryAndLevels";
import LatestArticles from "./components/LatestArticles";
import TimelineSection from "./components/TimelineSection";
import FaqPreview from "./components/FaqPreview";

export default function Home() {
  useSeo({
    title: "灵灵黑料｜灵灵争议回应与后续进展·声明解读与辟谣分析",
    description:
      "灵灵黑料事件中立梳理站：汇总灵灵本人回应、工作室声明逐句解读、争议传闻辟谣分析与后续进展时间线，帮你分清事实、观点与传闻，理性判断各方说法。",
    keywords: "灵灵黑料,灵灵回应,灵灵声明解读,灵灵后续进展,辟谣分析",
    path: "/",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: site.name,
        description: site.desc,
        inLanguage: "zh-CN",
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: site.name,
        email: site.email,
        description: "中立整理灵灵争议相关公开信息，标注信息可信等级。",
      },
      {
        "@context": "https://schema.org",
        "@type": "ItemList",
        name: "灵灵事件梳理文章列表",
        itemListElement: articles.map((a, i) => ({
          "@type": "ListItem",
          position: i + 1,
          name: a.title,
        })),
      },
    ],
  });

  return (
    <SiteLayout>
      <Hero />
      <CategoryAndLevels />
      <TimelineSection />
      <LatestArticles />
      <FaqPreview />
    </SiteLayout>
  );
}